<div class="popup-container">

<header>
  <label class="close_button" (click)="close()">x</label>
  <div class="header d-block roboto-medium">
    <label class="ms-3 mt-3 mb-3">{{heading}}</label>
  </div>
</header>

<form #contactForm="ngForm" (ngSubmit)="afterSubmit(contactForm)">
  
<div class="body" [style]="errormsg ? 'margin: 0% ' : 'margin: 0%;'">
  <div class="m-3 ms-4 me-4">
    <div class="row mb-3">
      <div class="col-4 d-flex">
        <label class="catlabel col-3 star-icon">T/M Title :</label>
        <select [(ngModel)]="tmTitle" [ngModelOptions]="{ standalone: true }" class="category col-7">
          <option value="SELECT A VALUE" disabled>SELECT A VALUE</option>
          <option *ngFor="let siteItem of tmTitleDropDown" [value]="siteItem.value"
          [disabled]= "siteItem.value === 'SELECT A VALUE'">
            {{ siteItem.value }}
          </option>
        </select>
      </div>
      <!-- <div id="charCounter" *ngIf="tmTitle=='SELECT A VALUE' && contactForm.submitted ">choose T/M Title </div> -->
      <div class="col-4 d-flex">
        <label class="catlabel col-3 star-icon" for="input2">Process :</label>
        <select [(ngModel)]="process" [ngModelOptions]="{ standalone: true }" class="category col-7">
          <option value="SELECT A VALUE" disabled>SELECT A VALUE</option>
          <option *ngFor="let siteItem of processDropDown" [value]="siteItem.value"
          [disabled]= "siteItem.value === 'SELECT A VALUE'">
            {{ siteItem.value }}
          </option>
        </select>
      </div>
      <div class="col-4 d-flex">
        <label class="catlabel col-5 star-icon" for="input3">Length of Service :</label>
        <select [(ngModel)]="lengthOfService" [ngModelOptions]="{ standalone: true }" class="category col-7">
          <option value="SELECT A VALUE" disabled>SELECT A VALUE</option>
          <option *ngFor="let siteItem of lengthOfServiceDropDown" [value]="siteItem.value" 
          [disabled]= "siteItem.value === 'SELECT A VALUE'">
            {{ siteItem.value }}
          </option>
        </select>
      </div>
    </div>

    <!-- ///////////////// -->
    <div class="row mb-3" id='message' *ngIf="(tmTitle=='SELECT A VALUE' || process=='SELECT A VALUE' || lengthOfService=='SELECT A VALUE') && contactForm.submitted "  >

      <div class="col-4 d-flex">
        <div   *ngIf="tmTitle=='SELECT A VALUE' && contactForm.submitted ">
        <p id="err_1"> Choose T/M Title</p>
      </div>
      </div>
      
      <div class="col-4 d-flex">
         
          <div   *ngIf="process=='SELECT A VALUE' && contactForm.submitted ">
          <p  id="err_2"> Choose Process</p>
        </div>
      </div>
      <div class="col-4 d-flex">
         
          <div   *ngIf="lengthOfService=='SELECT A VALUE' && contactForm.submitted ">
          <p  id="err_3"> Choose Length of Service</p>
        </div>
      </div>
    </div>
    

    <!-- ////////////// -->

    <div class="row mb-2">
      <div class="align-items-start col-4">
        <label class="catlabel col-5">Production Impact </label>
        <!-- <label class="catlabel ms-1"><input type="checkbox" [(ngModel)]="yesCheck" />YES</label>
        <label class="catlabel ms-3"><input type="checkbox" [(ngModel)]="noCheck" />NO</label> -->
        <label class="catlabel ms-1 col-2"><input type="radio" name="prodImpact" class="me-2"
            (change)="prodImpact('YES')" [checked]="productionImpact=='YES'?true:false" />YES</label>
        <label class="catlabel ms-3 col-2"><input type="radio" name="prodImpact" class="me-2"
          (change)="prodImpact('NO')" [checked]="productionImpact=='NO'?true:false" />NO</label>
        <div class="col-2"></div>
      </div>
      <div *ngIf="yesCheck" class="col-4 d-flex">
        <label class="catlabel col-5 star-icon">Production Impact
          Desc:</label>
        <textarea class="category col-7" #myInput (input)="checkChange(myInput.value)" rows="4" placeholder="Comments"
          [(ngModel)]="productionImpactDesc"></textarea>
      </div>
     
      <div class="col-4"></div>
    </div>
    <div class="row mb-2">
      <div class="align-items-start col-4">
        <div class="col-2"></div>
      </div>
      <div *ngIf="yesCheck" class="col-8 d-flex">
          <p id="charCounter">  Character Limit: {{maxi-ldiv}} left</p>
      </div>
      <div class="col-4"></div>
    </div>
    <!-- ///////////// -->

    <div class="row mb-2">
      <div class="align-items-start col-4">
        <div class="col-2"></div>
      </div>
      <div class="col-8 d-flex" *ngIf=" flag && productionImpactDesc?.length==0 && contactForm.submitted ">
        <p id="charCounter" class="production_checkMessage "> Provide Production Impact Desciption</p>
         </div>
      <div class="col-4"></div>
    </div>

    <!-- ///////////////// -->
    <div class="d-block flex-wrap mt-2 mb-2 align-items-baseline">
      <label class="catlabel mt-2 star-icon" for="">Production Investigation
        checkpoints : </label>
      <div class="row mt-3 checkLabel">
        <div class="col-3">
          <label class="checkcontainer">Standardized Work Followed
            <input type="checkbox" name="check_0" value="1" (change)="changedval($event)"   [checked]="swf == 4">
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="col-3">
          <label class="checkcontainer">TM Trained On Process
            <input type="checkbox"   name="check_1" value="2" (change)="changedval($event)"  [checked]="tm == 4">
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="col-3">
          <label class="checkcontainer"> Safety point included in SOP
            <input type="checkbox"  name="check_2" value="3" (change)="changedval($event)" [checked]="sop == 4">
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="col-3">
          <label class="checkcontainer">Layout/Space Adequate For Process
            <input type="checkbox"  name="check_3" value="4" (change)="changedval($event)"  [checked]="lsa == 4">
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="col-3">
          <label class="checkcontainer">Equipment In Good Condition
            <input type="checkbox"  name="check_4" value="5" (change)="changedval($event)"  [checked]="ecg == 4">
            <span class="checkmark"></span>
          </label>
        </div>
        <div class='checkBox' *ngIf="prodInvst.length==0 && contactForm.submitted">  Please Choose at least one Problem Investigation check point</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-4 d-flex">
        <label class="catlabel col-5 star-icon" for="input1">Description(Write in Detail) :</label>
        <textarea required class="category" name="myInput1" ngModel  #myInput1Ref="ngModel" rows="4" placeholder="Comments" [(ngModel)]="description"></textarea>
      </div>
      <div class="col-4 d-flex">
        <label class="catlabel col-5 star-icon" for="input2">Cause of Incident :</label>
        <textarea required class="category" name="myInput2" ngModel #myInput2Ref="ngModel" rows="4" placeholder="Comments" [(ngModel)]="causeOfIncident"></textarea>
      </div>
      <div class="col-4 d-flex">
        <label class="catlabel col-5 star-icon" for="input3">Lp Initiated Counter Measure :</label>
        <textarea  required class="category" name="myInput3" ngModel #myInput3Ref="ngModel" rows="4" placeholder="Comments"  [(ngModel)]="lpinitiatedMsg"></textarea>
      </div>
    </div>
    <div class="row mb-3" id="message12" >
      <div class="col-4 d-flex">
        <p id="charCounter1">  Character Limit: {{maxi-myInput1Ref.value?.length}} left</p>
       </div>
      <div class="col-4 d-flex">
        <p id="charCounter2">  Character Limit: {{maxi-myInput2Ref.value?.length}} left</p>
       </div>
      <div class="col-4 d-flex">
        <p id="charCounter3">  Character Limit: {{maxi-myInput3Ref.value?.length}} left</p>
       </div>
    </div>
    <div class="row mb-3" id="message" *ngIf="contactForm.invalid">
      <div class="col-4 d-flex">
         <p  *ngIf="myInput1Ref?.invalid && contactForm.submitted" class="production_checkMessage"  id="charCounter1"> Provide Description </p>
      </div>
      <div class="col-4 d-flex">
         <p *ngIf="myInput2Ref?.invalid && contactForm.submitted" class="production_checkMessage" id="charCounter2">Provide Cause of Incident </p>
      </div>
      <div class="col-4 d-flex">
         <p *ngIf="myInput3Ref?.invalid  && contactForm.submitted" class="production_checkMessage" id="charCounter3"> Provide Lp Initiated Counter Measure </p>
      </div>
    </div>
  </div>

  <!-- <div style="height: auto">
    <label class="catlabel" style="margin-top: 20px">Production Impact </label>
    <label class="catlabel"><input type="checkbox" style="width: 60px" [(ngModel)]="yesCheck" />YES</label>
    <label class="catlabel"><input type="checkbox" style="width: 60px" [(ngModel)]="noCheck" />NO</label>

    <label *ngIf="yesCheck" class="catlabel" style="margin-right: 10px; margin-left: 4%">Production Impact
      Desc:</label>
    <textarea *ngIf="yesCheck" class="category" style="width: 200px; height: 70px; resize: none" placeholder="Comments"
      [(ngModel)]="productionImpactDesc"></textarea>
  </div> -->



  <!-- <div>
    <label class="catlabel" style="margin-top: 20px">Production Investigation Checkpoints :</label>
    <label class="smallWidthCatlabel"><input type="checkbox" style="width: 60px" [checked]="swf == 4" />
      Standardised
      Work
      Followed</label>
    <label class="smallWidthCatlabel" style="margin-left: 5.5%"><input type="checkbox" style="width: 60px"
        [checked]="tm == 4" />Tm Trained On Process</label>
    <label class="smallWidthCatlabel"><input type="checkbox" style="width: 60px" [checked]="sop == 4" />
      Safety point
      included in
      SOP</label>
    <label class="smallWidthCatlabel"><input type="checkbox" style="width: 60px" [checked]="lsa == 4" />
      Layout/Space
      Adequate For
      Process</label>
    <label class="smallWidthCatlabel" style="margin-left: 5px"><input type="checkbox" style="width: 60px"
        [checked]="ecg == 4" />Equipment In Good
      Condition</label>
  </div> -->

  <!-- <div style="margin-top: 20px">
    <label class="catlabel" style="margin-right: 10px; margin-left: 4%">Description :</label>

    <textarea class="category" style="width: 200px; height: 70px;resize: none;" placeholder="Comments"
      [(ngModel)]="description"></textarea>

    <label class="catlabel" style="margin-right: 10px; margin-left: 4%">Cause of Incident :</label>

    <textarea class="category" style="width: 200px; height: 70px" placeholder="Comments"
      [(ngModel)]="causeOfIncident"></textarea>
  </div> -->
  <!-- <div style="margin-top: 20px">
    <label class="catlabel" style="margin-right: 10px; margin-left: 4%">Lp Initiated Counter Measure :</label>

    <textarea class="category" style="width: 200px; height: 70px" placeholder="Comments"
      [(ngModel)]="lpinitiatedMsg"></textarea>
  </div> -->
</div>

<label *ngIf="errormsg" class="errormsg"> {{ errormsg }} </label>
<div class="footer d-flex justify-content-between align-items-center fixed-bottom mt-2 py-2 ps-4">
  <!-- <button  *ngIf = "deleteAccessible" class="deletebutt roboto-medium" (click)="deleteEvent()"> DELETE </button>
  <div class="d-flex">
    <button class="submit black-button me-3 roboto-medium" (click)="saveClick()">UPDATE</button>
    <button class="cancel me-3 roboto-bold" (click)="close()"> CANCEL </button>
  </div> -->
  <div class="row" style="width: 100%;">
    <div class="col-6">
      <button type="button" *ngIf = "deleteAccessible" class="deletebutt roboto-medium" (click)="deleteEvent()"> DELETE </button>
    </div>
    <div class="col-6" style="padding-right: 0px;">
      <button type="button" class="cancel me-3 roboto-bold" (click)="close()"> CANCEL </button>
      <button type="submit" class="submit black-button me-3 roboto-medium" >UPDATE</button>
   
    </div>

  </div>
</div>
</form>
<!-- <div class="footer">
  <button mat-raised-button class="deletebutt" style="display: inline" (click)="deleteEvent()">
    DELETE
  </button>
  <button mat-raised-button class="submit" style="display: inline" (click)="saveClick()">
    UPDATE
  </button>
  <button class="cancel" style="display: inline; background: transparent; border: none !important">
    CANCEL
  </button>
</div> -->
</div>